<template>
    <div class="title" v-if="!isInApp" v-once>
        <p @click="jumpUrl">
            <img :src="getImgSrc(imageSrc)"  alt="download All Football App" width="100%">
        </p>
    </div>
</template>
<script>
    export default {
        name: 'headerTitle',
        data () {
            const query = this.$route.query || {};
            return {
                imageSrc: query && (query.language === 'en' || query.language === 'es') ? require(`../assets/header-${query.language}.jpg`) : require('../assets/header.png'),
                isInApp: process.env.VUE_ENV === 'server' ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
            };
        },
        mounted () {
            let utilObj = require('@/util/util.js');
            utilObj.checkOperamini();
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'browers', 'opreamini');
            }
        },
        methods: {
            jumpUrl () {
                let utilObj = require('@/util/util.js');
                utilObj.checkOperamini();
                if (utilObj.checkOperamini()) {
                    ga('send', 'event', 'm', 'download', 'opreamini');
                }
                fbq('track', 'Lead');
                let browers = {};
                let ua = navigator.userAgent.toLowerCase();
                browers.iPad = ua.match(/ipad/);
                browers.iPhone = ua.match(/iphone/);
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                browers.ie = ua.match(/iemobile/);
                browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
                browers.force_ssl = ua.match(/Android (5|6)/i);
                browers.is_ios_6 = ua.match(/iOS 6/i);
                browers.is_liveapp = ua.match(/LiveApp/i);
                if (browers.iOS) {
                    utilObj.jumpUrl();
                } else if (browers.Android) {
                    location.href = '/download';
                }
            }
        }
    };
</script>
<style lang="less">
    .title {
        margin: 0;
        padding: 0;
        height: 5rem;
        background: #fff;
    }

    .title p {
        display: block;
        height: 5rem;
    }

    .title img {
        width: 100%;
        height: 5rem;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// downloadHeader.vue?1d399cf1